import { useEffect } from 'react';
import { useColorPicker } from 'react-best-gradient-color-picker';
import { Button } from "../../components/ui/button"
import { useState } from "react"
import { SimpleColorPickerWithEyedropper } from './SimpleColorPickerWithEyedropper';//
import { BrushCleaningIcon, ImageIcon, Layers2Icon, PaintBucket, PlusIcon, RefreshCcw, Settings, ShirtIcon, TypeIcon, XIcon } from "lucide-react"
import { Slider } from "../../components/ui/slider"
import { Card, CardContent } from "../../components/ui/card"
import { Label } from "../../components/ui/label"
import { Input } from "../../components/ui/input"
import { ChromaticCircle } from "./ColorTable";

export function InputModal() {
    const [open, setOpen] = useState(true)
    const [color, setColor] = useState('rgba(210,211,213,1)');
    const { getGradientObject } = useColorPicker(color, setColor);
    const gradientObject = getGradientObject();

    useEffect(() => {
        const fn = () => setOpen(true)
        window.addEventListener("open-input-modal", fn)
        return () => window.removeEventListener("open-input-modal", fn)
    }, [])

    function handleApply(all: any) {
        const elem = document.getElementById("InputModal") as any;
        elem.style.display = "none";

        (window as any)["applyColorInput"](all);
    }

    function handleReset() {
        setOpen(false)
    }

    function handleCancelar() {
        const elem = document.getElementById("InputModal") as any;
        elem.style.display = "none";

        (window as any).imageClick = false;
        (window as any).pointer = null;
        $("#hide-iframe-menu").click();
    }

    const setRotationImage = function (value: any) {
        (window as any)["rotate-logo-iframe"](value)
    }

    const setScaleImage = function (value: any) {
        (window as any)["scale-logo-iframe"](value)
    }

    function handleDelete() {

        (window as any).fabricCanvas.remove((window as any).targetImage);
        (window as any).fabricCanvas.renderAll();
        (window as any)["updateCanvas"]();

        const elem = document.getElementById("InputModal") as any;
        elem.style.display = "none";
    }

    const setRotationText = function (value: any) {
        (window as any)["rotate-text-iframe"](value)
    }

    return (
        <div className='z-[1000000000] w-full md:w-[50%] h-[50%] md:h-full flex justify-center items-center hidden bottom-2 absolute md:relative' id="InputModal">

            <div className='!w-full h-full absolute' onClick={handleCancelar}></div>

            <div className="w-[800px] mirror rounded-xl p-3 max-w-[95%] h-full md:h-[90%]" id="InputModal2">

                <div className='!flex !flex-row text-white flex-wrap justify-center' id="option-input-iframe">
                    <span id="iframe-colors" data-id="colors" className='w-[15%] !m-[1px] mirror p-2 cursor-pointer text-center hover:bg-transparent hover:text-white flex items-center justify-center'>
                        <PaintBucket className='w-5' />
                        {!(window as any).isMobile ? (<span className='flex items-center justify-center ml-1 h-full'>Cor</span>) : null}
                    </span>
                    <span id="iframe-logos" data-id="logos" className='w-[15%] !m-[1px] mirror p-2 cursor-pointer text-center hover:bg-transparent hover:text-white flex items-center justify-center'>
                        <ImageIcon className='w-5' />
                        {!(window as any).isMobile ? (<span className='flex items-center justify-center ml-1 h-full'>Logo</span>) : null}
                    </span>
                    <span id="iframe-texts" data-id="texts" className='w-[15%] !m-[1px] mirror p-2 cursor-pointer text-center hover:bg-transparent hover:text-white flex items-center justify-center'>
                        <TypeIcon className='w-5' />
                        {!(window as any).isMobile ? (<span className='flex items-center justify-center ml-1 h-full'>Texto</span>) : null}
                    </span>
                    <span id="iframe-patterns" data-id="patterns" className='w-[15%] !m-[1px] mirror bg-transparent p-2 cursor-pointer text-center hover:bg-transparent hover:text-white flex items-center justify-center'>
                        <Layers2Icon className='w-5'></Layers2Icon>
                        {!(window as any).isMobile ? (<span className='flex items-center justify-center ml-1 h-full' >Padrões</span>) : null}
                    </span>
                    <span id="iframe-config" data-id="config" className='w-[15%] !m-[1px] mirror bg-transparent p-2 cursor-pointer text-center hover:bg-transparent hover:text-white  flex items-center justify-center'>
                        <Settings className='w-5'></Settings>
                        {!(window as any).isMobile ? (<span className='flex items-center justify-center ml-1 h-full'>Mais</span>) : null}
                    </span>
                    <span id="iframe-close" data-id="close" className='w-[15%] !m-[1px] mirror bg-transparent p-2 cursor-pointer text-center hover:bg-transparent hover:text-white  flex items-center justify-center'>
                        <XIcon></XIcon>
                        {!(window as any).isMobile ? (<span className='flex items-center justify-center ml-1 h-full'>Fechar</span>) : null}
                    </span>
                </div>

                <div className="py-4 flex input-options input-options-config w-full flex justify-center" id="">
                    <div className='flex flex-wrap mirror w-[70%] rounded-lg flex justify-center items-center p-5'>
                        <Button className="h-[50px] text-[13px] m-1 bg-secondary text-primary hover:text-background flex justify-start" id="state-fisica">
                            <ShirtIcon></ShirtIcon>
                            Física (Ligada)
                        </Button>
                        <Button className="h-[50px] edit-button text-[13px] m-1  bg-secondary text-primary hover:text-background flex justify-start" id="reset-iframe">
                            <RefreshCcw></RefreshCcw>
                            Resetar Layout
                        </Button>
                        <Button className="h-[50px] edit-button text-[13px] m-1  bg-secondary text-primary hover:text-background flex justify-start" id="clear-iframe">
                            <BrushCleaningIcon></BrushCleaningIcon>
                            Limpar Layout
                        </Button>
                    </div>
                </div>

                <div className="py-4 flex flex-col input-options input-options-colors" id="">
                    {/**<div className='w-[35%] h-[auto] overflow-y-auto flex items-center justify-center'>
                        <SimpleColorPickerWithEyedropper></SimpleColorPickerWithEyedropper>
                    </div> */}
                    <div className='flex justify-center items-start h-[25px]'>
                        <input id="check-iframe-all-colors" type="checkbox" defaultChecked></input>
                        <label className='ml-2 h-full flex justify-center items-center'>Aplicar a todos com a mesma cor</label>
                    </div>
                    <div className='w-full mt-0 md:mt-0 max-h-[350px] md:max-h-[100vh] flex flex-wrap overflow-y-auto justify-center' id="input-color-table">
                        <ChromaticCircle></ChromaticCircle>
                    </div>
                </div>

                <div className="py-4 flex input-options hidden input-options-texts flex-col" id="">
                    <div className='flex-row justify-center w-full flex'>
                        <Card id="" className="w-full md:w-[50%] border-none bg-transparent pt-5 m-2 !overflow-y-auto !h-[29vh]">
                            {/* Conteúdo */}
                            <CardContent id="card-iframe" className="space-y-4 ">

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-white">
                                    <div className="space-y-1">
                                        <Label htmlFor="content-text-iframe">Texto</Label>
                                        <Input id="content-text-iframe" className="bg-transparent mirror" defaultValue={"texto"} />
                                    </div>

                                    <div className="space-y-1">
                                        <Label htmlFor="color-text-iframe">Cor do texto</Label>
                                        <Input id="color-text-iframe" type="color" className="bg-transparent mirror" />
                                    </div>

                                </div>


                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-white">
                                    <div className="space-y-1">
                                        <Label htmlFor="border-text-iframe">Borda</Label>
                                        <Input
                                            id="border-text-iframe"
                                            type="number"
                                            className="bg-transparent mirror"
                                            defaultValue={0}
                                        />
                                    </div>
                                    <div className="space-y-1">
                                        <Label htmlFor="color-border-text-iframe">Cor da borda</Label>
                                        <Input
                                            className="bg-transparent mirror"
                                            id="color-border-text-iframe"
                                            type="color"
                                        />
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-white">
                                    <div className="space-y-1">
                                        <Label htmlFor="size-text-iframe">Tamanho</Label>
                                        <Input
                                            className="bg-transparent mirror"
                                            id="size-text-iframe"
                                            type="number"
                                            defaultValue={60}
                                        />
                                    </div>
                                    <div className="space-y-2 ">
                                        <Label>Rotação</Label>
                                        <Slider
                                            className="bg-secondary [&_[data-orientation=horizontal]]:bg-secondary [&_[data-orientation=horizontal]>span]:bg-primary"
                                            id="rotate-text-iframe"
                                            min={0}
                                            max={360}
                                            step={1}
                                            onValueChange={(value) => {
                                                setRotationText(value[0])
                                            }}
                                        />
                                    </div>
                                </div>

                            </CardContent>
                        </Card>

                        <Card id="" className="w-full md:w-[50%] border-none bg-transparent pt-5 m-2 max-h-[250px] md:max-h-[380px] overflow-y-auto !overflow-y-auto !h-[29vh]">
                            {/* Conteúdo */}
                            <CardContent id="card-fonts-iframe" className="space-y-4 grid grid-cols-3 gap-1 p-3 text-white">
                                <div id="font-A" title="aArigatouGozaimasu" className="flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-path="fonts/fonts/aArigatouGozaimasu" data-extension="ttf" style={{ fontFamily: "aArigatouGozaimasu" }}>
                                    <span className="text-[28px] leading-none font-preview" style={{ fontFamily: "aArigatouGozaimasu" }}>txt</span>
                                    <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">aArigatouGozaimasu</span>
                                </div>
                                <div id="font-B" title="AURORA-Regular" className="flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-path="fonts/fonts/AURORA-Regular" data-extension="ttf" style={{ fontFamily: "AURORA-Regular" }}>
                                    <span className="text-[28px] leading-none font-preview" style={{ fontFamily: "AURORA-Regular" }}>txt</span>
                                    <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">AURORA-Regular</span>
                                </div>
                                <div id="font-C" title="BrazierFlame" className="flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-path="fonts/fonts/BrazierFlame" data-extension="ttf" style={{ fontFamily: "BrazierFlame" }}>
                                    <span className="text-[28px] leading-none font-preview" style={{ fontFamily: "BrazierFlame" }}>txt</span>
                                    <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">BrazierFlame</span>
                                </div>
                                <div id="font-D" title="Catamaran" className="flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-path="fonts/fonts/Catamaran" data-extension="ttf" style={{ fontFamily: "Catamaran" }}>
                                    <span className="text-[28px] leading-none font-preview" style={{ fontFamily: "Catamaran" }}>txt</span>
                                    <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">Catamaran</span>
                                </div>
                                <div id="font-E" title="Coconut-House" className="flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-path="fonts/fonts/Coconut-House" data-extension="ttf" style={{ fontFamily: "Coconut-House" }}>
                                    <span className="text-[28px] leading-none font-preview" style={{ fontFamily: "Coconut-House" }}>txt</span>
                                    <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">Coconut-House</span>
                                </div>

                                <div id="font-F" title="KawitFree-CndItalic" className="flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-path="fonts/fonts/KawitFree-CndItalic" data-extension="ttf" style={{ fontFamily: "KawitFree-CndItalic" }}>
                                    <span className="text-[28px] leading-none font-preview" style={{ fontFamily: "KawitFree-CndItalic" }}>txt</span>
                                    <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">KawitFree-CndItalic</span>
                                </div>
                                <div id="font-G" title="Lavindir" className="flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-path="fonts/fonts/Lavindir" data-extension="ttf" style={{ fontFamily: "Lavindir" }}>
                                    <span className="text-[28px] leading-none font-preview" style={{ fontFamily: "Lavindir" }}>txt</span>
                                    <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">Lavindir</span>
                                </div>
                                <div id="font-H" title="LTBulletin-Medium" className="flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-path="fonts/fonts/LTBulletin-Medium" data-extension="ttf" style={{ fontFamily: "LTBulletin-Medium" }}>
                                    <span className="text-[28px] leading-none font-preview" style={{ fontFamily: "LTBulletin-Medium" }}>txt</span>
                                    <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">LTBulletin-Medium</span>
                                </div>
                                <div id="font-I" title="MakerVan-Regular" className="flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-path="fonts/fonts/MakerVan-Regular" data-extension="ttf" style={{ fontFamily: "MakerVan-Regular" }}>
                                    <span className="text-[28px] leading-none font-preview" style={{ fontFamily: "MakerVan-Regular" }}>txt</span>
                                    <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">MakerVan-Regular</span>
                                </div>
                                <div id="font-J" title="NCS-Rogueland-Slab-Bold" className="flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-path="fonts/fonts/NCS-Rogueland-Slab-Bold" data-extension="ttf" style={{ fontFamily: "NCS-Rogueland-Slab-Bold" }}>
                                    <span className="text-[28px] leading-none font-preview" style={{ fontFamily: "NCS-Rogueland-Slab-Bold" }}>txt</span>
                                    <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">NCS-Rogueland-Slab</span>
                                </div>
                                <div id="font-k" title="Number9" className="flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-path="fonts/fonts/Number9" data-extension="ttf" style={{ fontFamily: "Number9" }}>
                                    <span className="text-[28px] leading-none font-preview" style={{ fontFamily: "Number9" }}>txt</span>
                                    <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">Number9</span>
                                </div>
                                <div id="font-L" title="Shock" className="flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-path="fonts/fonts/Shock" data-extension="ttf" style={{ fontFamily: "Shock" }}>
                                    <span className="text-[28px] leading-none font-preview" style={{ fontFamily: "Shock" }}>txt</span>
                                    <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">Shock</span>
                                </div>
                                <div id="font-M" title="Talisman" className="flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-path="fonts/fonts/Talisman" data-extension="ttf" style={{ fontFamily: "Talisman" }}>
                                    <span className="text-[28px] leading-none font-preview" style={{ fontFamily: "Talisman" }}>txt</span>
                                    <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">Talisman</span>
                                </div>
                                <div id="font-N" title="teefont" className="flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-path="fonts/fonts/teefont" data-extension="ttf" style={{ fontFamily: "teefont" }}>
                                    <span className="text-[28px] leading-none font-preview" style={{ fontFamily: "teefont" }}>txt</span>
                                    <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">teefont</span>
                                </div>
                                <div id="font-O" title="BEST-IN-CLASS" className="flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-path="fonts/fonts/BEST-IN-CLASS" data-extension="ttf" style={{ fontFamily: "BEST-IN-CLASS" }}>
                                    <span className="text-[28px] leading-none font-preview" style={{ fontFamily: "BEST-IN-CLASS" }}>txt</span>
                                    <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">BEST-IN-CLASS</span>
                                </div>
                                <div id="font-P" title="Fut-1" className="flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-path="fonts/fonts/Fut-1" data-extension="ttf" style={{ fontFamily: "Fut-1" }}>
                                    <span className="text-[28px] leading-none font-preview" style={{ fontFamily: "Fut-1" }}>txt</span>
                                    <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">Fut-1</span>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                </div>

                <div className="py-4 flex input-options hidden input-options-logos" id="logos-iframe-panel">
                    <div id="input-options-logos-add" className='adding w-full flex justify-center'>
                        <Button id="iframe-logo-add" className="bg-transparent mirror text-white hover:bg-primary hover:text-background">
                            <PlusIcon></PlusIcon>
                            Adicionar Logo
                        </Button>
                    </div>
                    <div id="input-options-logos-edit" className='editing w-full justify-center hidden'>
                        <Card
                            className="bg-transparent rounded-lg h-full flex flex-col w-[300px]"
                        >
                            {/* Conteúdo com scroll */}
                            <CardContent className="flex-1 overflow-y-auto p-4 space-y-4">
                                {!(window as any).isMobile ? (<div
                                    id="iframe-logo-thumb"
                                    className="w-full rounded-md border bg-transparent"
                                />) : null}

                                <div className="space-y-2">
                                    <Label>Escala</Label>
                                    <Slider
                                        className="scale-logo-iframe [&_[data-orientation=horizontal]]:bg-background [&_[data-orientation=horizontal]>span]:bg-primary"
                                        min={1}
                                        max={100}
                                        step={0.2}
                                        onValueChange={(value) => { setScaleImage(value[0]) }}
                                    />
                                </div>
                                <div className="space-y-2">
                                    <Label>Rotação</Label>
                                    <Slider
                                        className="rotate-logo-iframe [&_[data-orientation=horizontal]]:bg-background [&_[data-orientation=horizontal]>span]:bg-primary"
                                        min={0}
                                        max={360}
                                        step={1}
                                        onValueChange={(value) => { setRotationImage(value[0]) }}
                                    />
                                </div>
                                <div className='w-full flex justify-center'>
                                    <Button
                                        className='m-1 input-options-logos input-options'
                                        variant="destructive"
                                        onClick={handleDelete}>
                                        Deletar Logo
                                    </Button>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                </div>

                <div className="py-4 flex input-options hidden input-options-patterns max-h-[90%]" id="">
                    <div className='w-full' id="patterns-list">
                        <div className='flex md:flex-wrap justify-start md:justify-center overflow-x-auto md:overflow-x-hidden w-full' id="iframe-categories-cliparts"></div>
                        <div className='flex flex-wrap justify-center overflow-y-auto p-5 max-h-[50vh] md:max-h-[70vh] mt-5' id="iframe-cliparts"></div>
                    </div>
                    <div id="patterns-edit"></div>
                </div>

                <div className="flex justify-end text-primary flex-wrap">

                    {/**<Button
                        className='m-1 bg-transparent mirror text-white hover:text-secondary'
                        onClick={handleCancelar}>
                        Fechar
                    </Button>

                    <Button
                        className='m-1 input-options-colors input-options bg-transparent mirror text-white hover:text-secondary'
                        onClick={handleReset}>
                        Resetar
                    </Button> */}
                    {/**<Button
                        id="apply-all-same-colors"
                        className='m-1 input-options-colors input-options bg-transparent mirror text-white hover:text-secondary  md:text-sm'
                        onClick={(value) => { handleApply(true) }}>
                        Aplicar Todos Mesma Cor
                    </Button>
                    <Button
                        className='m-1 input-options-colors input-options bg-transparent mirror text-white hover:text-secondary  md:text-sm'
                        onClick={(value) => { handleApply(false) }}>
                        Aplicar Cor
                    </Button> */}


                    <Button
                        className='m-1 bg-transparent mirror text-white hover:text-secondary'
                        id="add-text-iframe">
                        Adicionar Texto
                    </Button>
                    <Button
                        className='m-1 hidden text-iframe-edit bg-transparent mirror text-white hover:text-secondary'
                        id="delete-text-iframe">
                        Remover Texto
                    </Button>
                </div>
            </div>
        </div>
    )
}